import UsersRepository from "../../repositories/users";

export default {
  namespaced: true,
  state: {
    users: []
  },
  mutations: {
    // Set users
    setUsers(state, users) {
      state.users = users;
    }
  },
  actions: {
    // Get all users from api
    async fetchUsers({ commit }) {
      try {
        const { data } = await UsersRepository.get();
        commit("setUsers", data);
      } catch (error) {
        throw error;
      }
    },

    // Clean users
    clean({ commit }) {
      commit("setUsers", []);
    }
  },
  getters: {
    // Getsa user by uuid
    getUserByUuid: state => uuid => {
      return state.users.find(user => user.uuid === uuid);
    }
  }
};
